<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">組合員の声検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">受付番号</label>
          <div class="list-input-content">
            <input type="text" id="txti_ReceiptNumFrom" style="width:8rem" [tabindex]="0" maxlength="9" forcedEnabledMode="true"
              plessInputTextSub [restrict]="'[0-9]'" [(ngModel)]="kymw1900Model.receiptNumFrom">
            <label>～</label>
            <input type="text" id="txti_ReceiptNumTo" style="width:8rem" [tabindex]="0" maxlength="9" forcedEnabledMode="true"
              plessInputTextSub [restrict]="'[0-9]'" [(ngModel)]="kymw1900Model.receiptNumTo">
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <app-class-code-combo-box id="cmb_ClassList" [subid]="'cmb_ClassList'" [forcedEnabledMode]="'true'"
              [tabindex]="0" [blank]="true" [(ngModel)]="kymw1900Model.classCode">
            </app-class-code-combo-box>
          </div>

          <label class="list-input-title">商品名</label>
          <div class="list-input-content">
            <app-text-input id="txti_Subject" #txti_Subject [subid]="'txti_Subject'" [fullOnly]="true"
              [restrict]="'[ -￮]'" [maxChars]="600" [tabindex]="0" [forcedEnabledMode]="'true'"
              [displayCountField]="false" [(ngModel)]="kymw1900Model.subject">
            </app-text-input>
          </div>

          <label class="list-input-title">問合せ内容</label>
          <div class="list-input-content">
            <app-text-area id="txti_InquiryContents" #txti_InquiryContents [subid]="'txti_InquiryContents'"
              [fullOnly]="true" [restrict]="'[ -￮]'" [maxChars]="200" [tabindex]="0" [forcedEnabledMode]="'true'"
              [displayCountField]="false" [(ngModel)]="kymw1900Model.inquiryContents" [height]="72">
            </app-text-area>
          </div>

          <label class="list-input-title">会員受付日</label>
          <div class="list-input-content">
            <wj-input-date id="dtf_ReceiptDateFrom" #dtf_ReceiptDateFrom [tabindex]="0" format="yyyy/MM/dd"
              [min]="minDate" [max]="maxDate" [isRequired]="false" forcedEnabledMode="true"
              [(text)]="kymw1900Model.receiptDateFrom">
            </wj-input-date>
            <label>～</label>
            <wj-input-date id="dtf_ReceiptDateTo" #dtf_ReceiptDateTo [tabindex]="0" format="yyyy/MM/dd" [min]="minDate"
              [max]="maxDate" [isRequired]="false" forcedEnabledMode="true" [(text)]="kymw1900Model.receiptDateTo">
            </wj-input-date>
          </div>

          <label class="list-input-title">掲載区分</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_ImageBelongID" #cmb_ImageBelongID [subid]="'cmb_ImageBelongID'"
              [forcedEnabledMode]="'true'" [required]="false" [codeDiv]="'ct364'" [tabindex]="0" [blank]="false"
              [(ngModel)]="kymw1900Model.publishType">
            </app-code-combo-box>
          </div>

          <label class="list-input-title">会員生協</label>
          <div class="list-input-content">
            <app-coop-code-combo-box id="cmb_CoopList" #cmb_CoopList [subid]="'cmb_CoopList'"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw1900Model.coopCode">
            </app-coop-code-combo-box>
          </div>

          <label class="list-input-title">PEACE取込日(最終取込日)</label>
          <div class="list-input-content">
            <wj-input-date id="dtf_ImportDateFrom" #dtf_ImportDateFrom [tabindex]="0" format="yyyy/MM/dd"
              [min]="minDate" [max]="maxDate" [isRequired]="false" forcedEnabledMode="true"
              [(text)]="kymw1900Model.importDateFrom">
            </wj-input-date>
            <label>～</label>
            <wj-input-date id="dtf_ImportDateTo" #dtf_ImportDateTo [tabindex]="0" format="yyyy/MM/dd" [min]="minDate"
              [max]="maxDate" [isRequired]="false" forcedEnabledMode="true" [(text)]="kymw1900Model.importDateTo">
            </wj-input-date>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button autofocus id="btn_Search" class="btn-primary" [tabindex]="0" forcedEnabledMode="true"
            (click)="eventSearchHandler()">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>